<template>
  <div>
    <div class="vx-row">

      <div class="vx-col w-full">
        <vx-card title="BESPOKE PRICE LIST" >
          <template slot="actions">
              <vs-button v-can="'download-customers-bespoke-price-data'" @click.stop="onClickDownloadSheet" class="mr-4 mb-4" color="warning" type="border" id="bespoke-pricing-download-button">
                Download Pricing List
              </vs-button>
              <vs-button v-can="'create-edit-bespoke-pricing'" @click="onClickCreateSite" class="mr-4" color="primary" type="filled">Add</vs-button>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-input icon-pack="feather" icon="icon-search" placeholder="Search"
                      v-model="filters['search']"
                      class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
            <vs-table id="bespoke_price_table" v-can="'view-bespoke-pricing'" :max-items="(meta.per_page) ? meta.per_page : 10" :data="staff" @sort="handleSort" :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th width="10%" sort-key="formulation-code">ITS PRODUCT CODE</vs-th>
                <vs-th sort-key="formulation-name">ITS PRODUCT NAME</vs-th>
                <vs-th width="15%">CUSTOMER PRODUCT CODE</vs-th>
                <vs-th width="10%" sort-key="incoterm">INCOTERM</vs-th>
                <vs-th width="10%">LAST UPDATED DATE</vs-th>
<!--                <vs-th width="20%">LIST PRICE ({{account_currency}}/KG)</vs-th>-->
                <vs-th width="20%" v-can="'create-edit-bespoke-pricing'">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr @click.native="onClickCustomerSiteUpdate(data[indextr].id)" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].formulation_code">
                    {{ data[indextr].formulation_code}}
                  </vs-td>
                  
                  <vs-td :data="data[indextr].formulation_name">
                    {{ data[indextr].formulation_name }}
                  </vs-td>

                  <vs-td :data="data[indextr].formulation_name">
                    {{ data[indextr].customer_product_code || ''}}     
                  </vs-td>

                  <vs-td :data="data[indextr].incoterm">
                    {{ data[indextr].incoterm || 'N/A'}}
                  </vs-td>

                  <vs-td :data="data[indextr].updated_at">
                    {{ __dateTimeFormatterToDate(data[indextr].updated_at) }}
                  </vs-td>

<!--                  <vs-td :data="data[indextr].list_price">-->
<!--                    {{ (Number(data[indextr].list_price)).toFixed(2)}}-->
<!--                  </vs-td>-->

                  <vs-td v-can="'create-edit-bespoke-pricing'">
                    <div class="vx-row">
                      <vx-tooltip :text="`View and update ${tr.formulation_code} bespoke price`" position="top">
                        <vs-button class="mr-2" @click.stop="onClickCustomerSiteUpdate(data[indextr].id)"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip :text="`Delete ${tr.formulation_code} bespoke price`" position="top">
                        <vs-button class="mr-2" @click.stop="onClickRemoveBespokePriceConfirm(data[indextr].id)"
                                   size="small" color="danger" type="border" icon-pack="feather" icon="icon-delete"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>
            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5">
            </vs-pagination>

          </div>
        </vx-card>
      </div>
    </div>
    <create-customer-bespoke-price-pop-up v-bind:account_currency="account_currency" ref="createCustomerBespokePricePopUp"/>
   <update-customer-bepoke-price-pop-up v-bind:account_currency="account_currency" ref="updateCustomerBepokePricePopUp"/>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const CustomerRepository = RepositoryFactory.get('customer')
  import CreateCustomerBespokePricePopUp from '@/components/popups/customer/bespoke-price/CreateCustomerBespokePricePopUp'
  import UpdateCustomerBepokePricePopUp from '@/components/popups/customer/bespoke-price/UpdateCustomerBepokePricePopUp'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import { defaultPagination, perPageList } from "@/constants/config";

  export default {
    name: 'CustomerBespokePriceList',
    data () {
      return {
        staff: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        customerId: '',
        perPage: defaultPagination,
        descriptionItems: perPageList,
      }
    },
    props: {
      account_currency  : {type: String,  default: ''}
    },
    components: {
      'v-select': vSelect,
      CreateCustomerBespokePricePopUp,
      UpdateCustomerBepokePricePopUp
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    async mounted () {
      this.customerId = this.$route.params.id
      if (this.$route.query.edit_id) {
        await this.$refs.updateCustomerBepokePricePopUp.openPopup(this.$route.query.edit_id)
      }
    },
    methods: {
      async refreshData () {
        this.fetchCustomerBespokeList()
      },

      async fetchCustomerBespokeList() {
        await this.$vs.loading({
          container: `#bespoke_price_table`,
          scale: 0.45
        })
        const {data} = await CustomerRepository.getListOfBespokeList(this.customerId, this.page, this.filterQuery, this.perPage, this.sort)
        this.staff =  data.data
        this.meta = data.meta
        this.$vs.loading.close(`#bespoke_price_table > .con-vs-loading`)
      },

      async onClickCreateSite () {
        await this.$refs.createCustomerBespokePricePopUp.openPopup(this.customerId)
      },
      async onClickCustomerSiteUpdate (id) {
        await this.$refs.updateCustomerBepokePricePopUp.openPopup(id)
      },
      async onClickRemoveBespokePriceConfirm(id) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Warning',
          text: 'Do you want to permanently delete this item? This operation is irreversible.',
          accept: this.onClickRemoveBespokePrice,
          acceptText: 'Confirm',
          parameters: [id]
        })
      },
      async onClickRemoveBespokePrice (params) {
        const vue = this;
        await this.$vs.loading({
          container: `#bespoke_price_table`,
          scale: 0.45
        })
        try {
          await CustomerRepository.removeCustomerBespokePrice(params[0])
          await this.refreshData()
          this.showSuccessMessage('bespoke price deleted successfully')
        }catch (e) {
          this.$vs.loading.close(`#bespoke_price_table > .con-vs-loading`)
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close(`#bespoke_price_table > .con-vs-loading`)
      },


      filterQueryUpdate (){
        this.fetchCustomerBespokeList()
      },
      changePage(index) {
        this.page = 1
        this.perPage = this.descriptionItems[index]
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.fetchCustomerBespokeList()
        }
      },

      projectBriefColorFactory(id) {
        switch (id) {
          case 1:
            return 'warning';
          case 2:
            return 'primary';
          case 3:
            return 'danger';
        }
      },
      onClickFormula(id) {
        this.$router.push({path: `/pages/formulations/${id}`})
      },
      async onClickDownloadSheet() {
        await this.$vs.loading({
          container: '#bespoke-pricing-download-button',
          scale: 0.45
        })
        try {
          const response = await CustomerRepository.downloadBespokeSheet(this.customerId)
          let fileURL = window.URL.createObjectURL(new Blob([response.data]));
          let fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', `Customer Bespoke Pricing List.xlsx`);
          document.body.appendChild(fileLink);
          fileLink.click();
        } catch (e) {

        }
        this.$vs.loading.close('#bespoke-pricing-download-button > .con-vs-loading')
      }

    },
    watch : {
      page() {
        this.fetchCustomerBespokeList()
      },
    perPage() {
        this.fetchCustomerBespokeList()
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
